import React from 'react'
import { ConnectedGuide } from '../category-guides-module/category-guide-card'
import { useMeta, useEntity } from '../helpers/selectors'

const ConnectedGuideCard = (props) => {
  const {
    showDescription,
    showDate,
    dateFormat,
    showLink,
    linkText,
    variant: metaVariant = props.variant,
  } = useMeta(['guideCard'], {})

  const { link, url, variants = [], variant, sys: { updatedAt } = {} } = useEntity(props.entity)

  return (
    <ConnectedGuide
      {...props}
      showDescription={
        props.showDescription !== undefined && props.showDescription && showDescription
      }
      showDate={showDate}
      showLink={showLink}
      dateFormat={dateFormat}
      linkText={linkText}
      variant={variant || metaVariant || 'readMoreCard'}
      entity={link || variants[0]}
      url={url}
      updatedAtDate={updatedAt}
    />
  )
}

export default ConnectedGuideCard
